import { IBSKTDotHocActionTypes } from "../../action-types/category/IBSKTDotHocActions";
import { IBSKTDotHocReducer } from "../../reducer-model/category/IBSKTDotHocReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: IBSKTDotHocReducer = {
  status: eReducerStatusBase.is_not_initialization,
  bsktDotHocs: [],
};
export const bsktDotHocReducer = (
  state: IBSKTDotHocReducer = iniState,
  action: IBSKTDotHocActionTypes,
): IBSKTDotHocReducer => {
  switch (action.type) {
    case "BSKT_DOT_HOC_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "BSKT_DOT_HOC_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        bsktDotHocs: action.payload,
      };
    case "BSKT_DOT_HOC_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    default:
      return state;
  }
};
